import { getIntroAlertObject } from '../../../../login/src/form/getIntroAlertObject.js';
import { setElementVisible } from '../../../../shared/DOM/setElementVisible.js';

/**
 * Partial view del Viewdocs: OTP
 *
 * @returns Otp View json
 */
export function getOtpView() {
  return {
    properties: [
      {
        type: 'object',
        name: 'otp.html',
        cols: 4,
        properties: [
          {
            name: 'otpAlert',
            type: 'alert',
            metadata: {
              closable: false,
              style: 'danger',
            },
            cols: 8,
          },
          {
            model: 'code',
            // Los textos son más aclaratorios al revés
            title: edicom.locale.translate('login.otpcode_placeholder'),
            type: 'string',
            required: true,
            placeholder: edicom.locale.translate('login.otpcode'),
            metadata: {
              icon: 'lock',
              // minlength: No podemos limitarlo a 6 por el código de recuperación
              maxlength: 6,
            },
            pattern: '/^\\d{1,6}$/',
            cols: 8,
          },
          {
            name: 'btnOtp',
            type: 'button',
            title: edicom.locale.translate('global.aceptar'),
            metadata: {
              icon: 'check',
              style: 'primary fill',
            },
            cols: 8,
          },
        ],
      },
      getIntroAlertObject('viewdoc.step.intro.info', 'viewdoc.step.intro.info3'),
    ],
  };
}

export function getOtpViewAlert() {
  return document.querySelector('ewc-alert[view-name="otpAlert"]');
}

export function getOtpBtnSubmit() {
  return document.querySelector('ewc-button[view-name="btnOtp"]');
}

export function hideOtpError() {
  const eAlert = getOtpViewAlert();
  setElementVisible(eAlert, false);
}

export function showOtpError(message, params) {
  const eAlert = getOtpViewAlert();
  setElementVisible(eAlert, true);
  eAlert.innerHTML = edicom.locale.translate(message, params);
}
